import { TmFormElement } from '@thiememeulenhoff/lit-sdk';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles, tag } from './feedback-text-input.styles';

@customElement(tag)
export class FeedbackTextInputComponent extends TmFormElement {
  static override styles = styles;

  @property({ type: String, reflect: true })
  override placeholder?: string;

  @property({ type: Boolean, reflect: true })
  loading = false;

  @property({ type: Number, reflect: true })
  maxlength = 500;

  #htmlPlaceholder(text: string) {
    if (!text) return text;

    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;

    return textarea.value;
  }

  override handleInput(event: InputEvent) {
    super.handleInput(event);
  }

  override handleChange(event: Event) {
    super.handleChange(event);
  }

  #handleIconClick() {
    this.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    this.dispatchLocalEvent({ eventName: 'icon-click' });
  }

  override render() {
    const htmlPlaceholder = this.#htmlPlaceholder(this.placeholder ?? '');

    return html`
      <div class="input-wrapper">
        <input
          id="inputElement"
          part="input"
          data-test="feedback-input"
          role="textbox"
          .placeholder=${htmlPlaceholder || nothing}
          ?readonly=${this.readonly}
          .value=${this.value}
          ?disabled=${this.disabled}
          loading="${this.loading}"
          @input=${this.handleInput}
          @change=${this.handleChange}
          maxlength=${this.maxlength}
        />
        ${this.loading
          ? html`<a-loader></a-loader>`
          : html`
              <a-icon
                name="paper-plane"
                class="icon"
                @click=${this.#handleIconClick}
              ></a-icon>
            `}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-feedback-text-input': FeedbackTextInputComponent;
  }
}
